import _ from 'lodash';
import * as actionTypes from 'constants/ActionTypes';
import mockOrder from 'mocks/tc/order.js';

const tcOrders = ( 
    state = { 
        items: [],
        user: {
            email: '',
            company: '',
            name: '',
            surname: '',
            phones: [{
                code: '',
                phone: '',
            }],
        },
    }, 
    action
) => {
    switch (action.type) {
        case actionTypes.ADD_TC_ORDER: {
            const newState = _.cloneDeep(state);
            newState.items.push({ ...(_.cloneDeep(mockOrder)) });
            return newState;
        }
        case actionTypes.CREATE_TC_ORDERS: {
            return {
                ...state,
                items: action.items,
            };
        }
        case actionTypes.UPDATE_TC_ORDER: {
            let newState = _.cloneDeep(state);
            newState.items[action.numberOrder] = action.newTcOrder;
            return newState;
        }
        case actionTypes.UPDATE_TC_ORDER_USER: {
            const newState = _.cloneDeep(state);
            newState.user = action.user;
            return newState;
        }
        case actionTypes.REMOVE_LAST_TC_ORDER: {
            const newState = _.cloneDeep(state);
            newState.items.splice(-1, 1);
            return newState;
        }
        default: {
            return state;
        }
    }
}

export default tcOrders;



// WEBPACK FOOTER //
// ./app/reducers/tc/orders.js